    const translations = {
        "az": {
            "bio": "Bioqrafiya",
            "isimkanlari": "İmkanlar və İnkişaf Platforması",
            "karyeramerkezi": "Karyera Mərkəzi",
            "karyeramerkezi1": "İş elanları",
            "karyeramerkezi2": "İnvestisiya təklifləri",
            "karyeramerkezi3": "Tədbir və Təlimlər",
            "insanresurs": "İstedad və Tərəfdaşlıq Portalı",
            "insanresurs1": "CV Bankı",
            "insanresurs2": "Tərəfdaşlıq və Startap Layihələri",
            "investclub": "Özbahçeci İnvest Club",
            "projects": "Layihələr",
            "coaching": "Kouç Sessiyaları",
            "allcoaching": "Bütün kouç sessiyalar",
            "news": "Xəbərlər",
            "allnews": "Bütün xəbərlər",
            "subscribe": "Abunəlik",
            "subscoaching": "Kouç sessiyaları",
            "subsisimkanlari": "İş imkanları və inkişaf bazarı",
            "subsemek": "Əməkdaşlıq",
            "signin": "Daxil ol",
            "homeSliderTitle": "“Uğur hekayənizi birlikdə yazaq”",
            "homeSliderDesc": '"Üşenme, erteleme, vazgeçme."',
            "homeSliderDesc1": '"Siz sadəcə inanın və hədəfə odaklanın."',
            "homeSliderTitle1": "“Biznesinizi uğurlu edəcək seçim bizik!”",
            "whyozbahceci": "Nə üçün Özbahçeci?",
            "successprojects": "Uğurlu Layihələrimiz",
            "projectsdesc": "Keçmişdə Uğur, Bu Gün İrəliləyiş, Gələcəkdə Zirvə!",
            
            "projectsall": "Hamısı",
            "projectstamamlanan": "Bacardıq",
            "projectstamamlanmayan": "Bacarırıq",

            "projectstamamlanmayan1": "Bacaracağıq",

            "projectsother" : "Digər layihələrimiz",

            

            // bunlar qalib
            "copyright":"Müəllif hüquqları qorunur.",
            "homedate":"Seçdİyİnİz Tarİxə Uyğun Məzmunları Kəşf Edİn",
            "selectdate":"Tarİx seçİmİ",
            "datetitle":"Seçilmiş Tarixə Əsasən Tədbirlər, Xəbərlər, Fotoğraflar, Onlayn Görüşlər və Sessiyalar Kimi Müxtəlif Məzmunlarla Bağlı Ətraflı Məlumatları Yoxlayın.",
            "datedesc":"Bu səhifədə, seçdiyiniz tarixə uyğun olaraq layihə, xəbər və bloglarla bağlı ətraflı məlumatları əldə edə bilərsiniz. Hər bir tarix, müvafiq məzmunla əlaqəli məlumatları təqdim edir, beləliklə siz layihələr və xəbərlər barədə ən son yenilikləri izləyə bilərsiniz.",
            "readmore":"Daha ətraflı",
            "testimonials":"Rəylər",
            "testtitle":"İnsanlar Niyə <span>*Bizi* </span> Sevir?",
            "testdesc":"Xidmətimizin keyfiyyəti ilə bağlı düşüncələri eşitmək istəyirsiniz? Burada müştərilərimizin fikirlərini tapa bilərsiniz. Hər şey açıq və sadədir, beləliklə siz də bizimlə tam razı olacaqsınız.",
            "contactweTitle":"Bizdən soruşun",
            "contactweDesc":"Sual, təklif və ya hər hansı bir məsələyə dair dəstək almaq üçün bizimlə əlaqə qurmaq çox asandır. Əlaqə səhifəmizə keçid edərək, müraciətinizi bizə təqdim edə bilərsiniz. Ən qısa zamanda sizinlə əlaqə saxlanılacaqdır.",
            "contactwe":"Bizimlə Əlaqə",
            "contactDesc":"",
            "nameandemail":"İstifadəçi adı və yaxud e-poçt",
            "pass":"Şifrə",
            "check":"Yadda saxla",
            "newprofil":"  Hesabınız yoxdursa, yeni hesab yaratmağınız tövsiyə  olunur.",
            "createnewprofile":"Yeni hesab yaradın.",
            "signup":"Qeydiyyat",
            "name":"Ad",
            "lastname":"Soyad",
            "email":"E-poçt",
            "passconfirm":"Şifrəni Təkrarla",
            "mobil":"Mobil",
            "contracttitle":"Müqavilə və İstifadəçi Şərtlərini oxuyun",
            "profil":"Hesabınız mı var ?",
            "sucsccontract":" Müqavilə və İstifadəçi Şərtlərini oxudum və qəbul edirəm.",
            "contacttitle1":"MÜQAVİLƏ",
            "more":"Daha çox" ,
            "othernew":"Digər xəbərlərimiz",
            "note":"Mesajınız",
            "submit":"Göndər",
            "contactustitle":"Əlaqə Məlumatları",
            "contactusdesc":"Bizimlə əlaqə qurmaq üçün aşağıdakı məlumatlardan istifadə edə bilərsiniz. Həmçinin, sosial media platformalarımız üzərindən də bizimlə əlaqə saxlaya bilərsiniz.",
            "address":"Ünvan",
            "addressDesc":"Bakı / Azərbaycan",
            "contactwork":" İş saatları",
            "contactworktime":"Bazar ertəsi - Cümə",
            "contactworktime1":"Şənbə və Bazar ",
            "contactsocial":"Sosial Media Hesablarımız",
            "terms":"PORTALDAN  İSTİFADƏ QAYDALARI VƏ ŞƏRTLƏRİ",
            "privacy":"Məxfilik Siyasəti",
            "bioTitle":"ÜŞENME,</br> ERTELEME, </br> VAZGEÇME",
            "about":"Haqqımızda",
            "homePage":"Ana Səhifə",
            "filter":"Filter",
            "gender":"Cinsiyyət",
            "man":"Kişi",
            "woman":"Qadın",
            "maasaraligi":"Maaş aralığı",
            "maasdan":"₼-dan",
            "maasqeder":"₼-a qədər",
            "selectcat":"Kateqoriya seç :",
            "allCat":"Bütün kateqoriyalar :",
            "education":"Təhsil :",
            "ali":"Ali",
            "natamam":"Natamam",
            "orta":"Orta",
            "isrejimi":"İş-rejimi",
            "tamstat":"Tam-ştat",
            "yarim":"Yarım-ştat",
            "frilans":"Frilans",
            "tecrubeci":"Təcrübəçi",
            "uzaqdan":"Uzaqdan",
            "muveqqeti":"Müvəqqəti iş",
            "istecrubesi":"İş təcrübəsi",
            "birildenaz":"1 ildən az",
            "birildenucileqeder":"1 ildən 3 ilə qədər",
            "ucilden5ileqeder":"3 ildən 5 ilə qədər",
            "besildencox":"5 ildən yüksək",
            "dilbilikleri":"Dil bilikləri",
            "butunnamizedler":"Bütün namizədlər",
            "toplamnamized":"toplam namizəd",
            "searchnamized":"Axtardığınız vəzifəni daxil edin...",
            "sirala":"Sırala",
            "nameasc":"Adı üzrə A-Z",
            "namedesc":"Adı üzrə Z-A",
            "positionasc":"Vəzifəsi üzrə A-Z",
            "positiondesc":"Vəzifəsi üzrə Z-A",
            "salaryasc":"Maaş artan",
            "salarydesc":"Maaş azalan",
            "clear":"Təmizlə",
            "searchnotfound":"Axtarışınıza uyğun məlumat tapılmadı.",
            "date":"Yerləşdirildi :",
            "allcompany":"Bütün şirkətlər",
            "toplamsirket":"toplam şirkət",
            "searchcompany":"Şirkət axtar",
            "companyasc":"Adına görə (A-Z)",
            "companydesc":"Adına görə (Z-A)",
            "notfoundcompany":"Şirkət tapılmadı",
            "city":"Şəhər",
            "kateqoriya":"Kateqoriya",
            "maas":"Maaş",
            "yerlesme":"Yerləşmə tarixi",
            "bitme":"Bitmə tarixi",
            "description":"Təsvir :",
            "telebler":"Tələblər :",
            "muraciet":"Müraciət et",
            "oxsarvakansiya":"Oxşar vakansiyalar",
            "elan":"ELAN",
            "vezife":"Vəzifə",
            "buildcareer":"Karyeranızı bizimlə qurun!",
            "buildcareerdesc":"Turanozbahceci.az Azərbaycanda iş axtaranlarla işəgötürənləri bir araya gətirən innovativ iş platformasıdır. Ən son vakansiyalar, freelancer işlər, təcrübə proqramları və karyera inkişafına dair faydalı resurslar burada birləşir! İş axtarırsan? Turanozbahceci.az sənin üçün ən uyğun iş elanlarını tapmağa, CV-ni yerləşdirməyə və işəgötürənlərlə birbaşa əlaqə yaratmağa imkan verir. Müxtəlif sahələr üzrə vakansiyalar, startap imkanları, korporativ elanlar və dövlət sektorundakı karyera fürsətləri yalnız bir klik uzaqlığındadır. İşəgötürənsiniz? Turanozbahceci.az ilə elanlarınızı yerləşdirin, geniş iş axtaran bazasına çıxış əldə edin və ən uyğun namizədləri tez bir zamanda tapın. Platformamız işə qəbul prosesini sürətləndirir və sizə istedadlı namizədlərlə rahat şəkildə görüşmək imkanı yaradır.",
            "welcome":"Xoş",
            "welcome1":"gəldiniz",
            "emekdasliq":"Əməkdaşlıq",
            "hesabmelumatlari":"Hesab məlumatları",
            "logout":"Çıxış",
            "panel":"İdarəetmə paneli",
            "hello":"Salam,",
            "paneldesc":"Hesabınızın idarəetmə panelindən, iş elanlarınızı yerləşdirə və görə bilərsiniz, göndərmə və ödəniş ünvanlarınızı idarə edə bilərsiniz, həmçinin şifrənizi və hesab məlumatlarınızı redaktə edə bilərsiniz.",
            "username":"İstifadəçi adı soyadı :",
            "sifreniyenile":"Şifrəni yenilə",
            "hazirki":"Hazırki şifrə",
            "yeni":"Yeni şifrə",
            "sifretestiq":"Şifrəni təsdiqləyin",
            "activevac":"Hazırda",
            "activevac1":"vakansiyanız aktivdir",
            "createjob":"İş elanı yarat",
            "iselaniyerlesdirmek":"İş elanı yerləşdirmək",
            "min_maas":"Minimum maaş",
            "max_maas":"Maksimum maaş",
            "old":"Yaş",
            "max":"Maksimum",
            "select":"Seç:",
            "namizedeteleb":"Namizədə tələblər",
            "namizedbacariq":"Namizədin bacarıqları və təcrübəsi haqqında məlumat daxil edin.",
            "isbarede":"İş barədə məlumat",
            "isinvezifesi":"İşin vəzifələri və tələbləri haqqında məlumat daxil edin.",
            "companyname":"Şirkətin adı",
            "elaqedar":"Əlaqədar şəxs",
            "yerlesdirin":"Yerləşdirin",
            "karyerairelileyis":"Karyera İrəlİləyİş",
            "kouc":"Kouç",
            "cvyerlesdirmek":"CV yerləşdirmək",
            "fathername":"Ata adı",
            "img":"Şəkil",
            "etrafli":"Ətraflı",
            "ozunuz":"Özünüz haqqında məlumat.",
            "istecrubesihaqqinda":"İş təcrübəniz haqqında məlumat.",
            "bacariqlar":"Bacarıqlar",
            "elavemelumat":"Əlavə məlumat",
            "view":"Görünüş",
            "coachingTitle":" Turan Özbahçeci - Kouçinq Sessiyaları və Şəxsi İnkişaf Videoları",
            "coachingDesc":"Turan Özbahçeci'nin kouç sessiyaları ilə həyatınızı dəyişdirin! Bu videolarda məqsədlərinizə çatmaq, şəxsi inkişaf və müvəffəqiyyətə  nail olmaq üçün praktiki məsləhətlər və motivasiya tapacaqsınız.",
            "abuneol":"Abunə ol",
            "month":"ay",
            "year":"il",
            "populyar":"ƏN POPULAR"
            
        },
        "tr": {
            "bio": "Biyografi",
            "isimkanlari": "Fırsatlar ve Gelişim Pazarı",
            "karyeramerkezi": "Kariyer Merkezi",
            "karyeramerkezi1": "İş ilanları",
            "karyeramerkezi2": "Yatırım teklifleri",
            "karyeramerkezi3": "Etkinlikler ve Eğitimler",
            "insanresurs": "Yetenek ve İş Birliği Portalı",
            "insanresurs1": "CV Bankası",
            "insanresurs2": "İş Birlikleri / Startup Projeleri",
            "investclub": "Özbahçeci Yatırım Kulübü",
            "projects": "Projeler",
            "coaching": "Koçluk Oturumları",
            "allcoaching": "Tüm koçluk oturumları",
            "news": "Haberler",
            "allnews": "Tüm haberler",
            "subscribe": "Abonelik",
            "subscoaching": "Koçluk oturumları",
            "subsisimkanlari": "İş imkanları ve gelişim pazarı",
            "subsemek": "İşbirliği",
            "signin": "Giriş yap",
            "homeSliderTitle": "“Başarı hikayenizi birlikte yazalım”",
            "homeSliderDesc": "\"Yılma, erteleme, vazgeçme.\"",
            "homeSliderDesc1": "\"Sadece inan ve hedefe odaklan.\"",
            "homeSliderTitle1": "“İşinizi başarılı yapacak seçim biziz!”",
            "whyozbahceci": "Neden Özbahçeci?",
            "successprojects": "Başarılı Projelerimiz",
            "projectsdesc": "Geçmişte Başarı, Bugün İlerleme, Gelecekte Zirve!",
          
            "projectsall": "Hepsi",
            "projectstamamlanan": "Başardık",
            "projectstamamlanmayan": "Başarıyoruz",
            "projectstamamlanmayan1": "Başaracağız",
          
            "projectsother" : "Diğer projelerimiz",
            "copyright":"Telif hakları korunmaktadır.",
            "homedate":"Seçtiğiniz Tarihe Uygun İçerikleri Keşfedin",
            "selectdate":"Tarih seçimi",
            "datetitle":"Seçilen tarihe dayalı olarak Etkinlikler, Haberler, Fotoğraflar, Çevrim İçi Toplantılar ve Oturumlar gibi çeşitli içeriklerle ilgili detaylı bilgileri inceleyin.",
            "datedesc":"Bu sayfada, seçtiğiniz tarihe uygun projeler, haberler ve bloglarla ilgili detaylı bilgilere ulaşabilirsiniz. Her bir tarih, ilgili içeriklerle bağlantılı bilgileri sunar, böylece projeler ve haberler hakkında en son gelişmeleri takip edebilirsiniz.",
            "readmore":"Daha fazla",
            "testimonials":"Yorumlar",
            "testtitle":"İnsanlar Neden <span>*Bizi* </span> Seviyor?",
            "testdesc":"Hizmetimizin kalitesiyle ilgili düşünceleri duymak ister misiniz? Burada müşterilerimizin görüşlerini bulabilirsiniz. Her şey açık ve basit, böylece siz de bizimle tamamen aynı fikirde olacaksınız.",
            "contactweTitle":"Bizden soruşun",
            "contactweDesc":"Soru, öneri veya herhangi bir konuda destek almak için bizimle iletişime geçmek çok kolay. İletişim sayfamıza geçerek, talebinizi bizlere iletebilirsiniz. En kısa zamanda sizinle iletişime geçilecektir.",
            "contactwe":"Bizimle İletişime Geçin",
            "contactDesc":"",
            "nameandemail":"Kullanıcı adı veya e-posta",
            "pass":"Şifre",
            "check":"Beni hatırla",
            "newprofil":"Hesabınız yoksa, yeni hesap oluşturmanız önerilir.",
            "createnewprofile":"Yeni hesap oluştur.",
            "signup":"Kayıt ol",
            "name":"Ad",
            "lastname":"Soyad",
            "email":"E-posta",
            "passconfirm":"Şifreyi Tekrarla",
            "mobil":"Mobil",
            "contracttitle":"Sözleşme ve Kullanıcı Şartlarını okuyun",
            "profil":"Hesabınız var mı?",
            "sucsccontract":"Sözleşme ve Kullanıcı Şartlarını okudum ve kabul ediyorum.",
            "contacttitle1":"SÖZLEŞME",
            "more":"Daha fazla",
            "othernew":"Diğer haberlerimiz",
            "note":"Mesajınız",
            "submit":"Gönder",
            "contactustitle":"İletişim Bilgileri",
            "contactusdesc":"Bizimle iletişime geçmek için aşağıdaki bilgilerden yararlanabilirsiniz. Ayrıca, sosyal medya platformlarımız üzerinden de bizimle iletişim kurabilirsiniz.",
            "address":"Adres",
            "addressDesc":"Baku / Azerbaycan",
            "contactwork":"Çalışma saatleri",
            "contactworktime":"Pazartesi - Cuma",
            "contactworktime1":"Cumartesi ve Pazar",
            "contactsocial":"Sosyal Medya Hesaplarımız",
            "terms":"PORTALDAN KULLANIM KOŞULLARI",
            "privacy":"Gizlilik Politikası",
            "bioTitle":"YILMA,</br> ERTELEME, </br> VAZGEÇME",
            "about":"Hakkımızda",
            "homePage":"Anasayfa",
            "filter":"Filtrele",
            "gender":"Cinsiyet",
            "man":"Erkek",
            "woman":"Kadın",
            "maasaraligi":"Maaş aralığı",
            "maasdan":"₼-dan",
            "maasqeder":"₼-a kadar",
            "selectcat":"Kategori seç :",
            "allCat":"Tüm kategoriler :",
            "education":"Eğitim :",
            "ali":"Yüksek",
            "natamam":"Tamamlanmamış",
            "orta":"Orta",
            "isrejimi":"İş düzeni",
            "tamstat":"Tam zamanlı",
            "yarim":"Yarı zamanlı",
            "frilans":"Freelance",
            "tecrubeci":"Stajyer",
            "uzaqdan":"Uzaktan",
            "muveqqeti":"Geçici iş",
            "istecrubesi":"İş deneyimi",
            "birildenaz":"1 yıldan az",
            "birildenucileqeder":"1 yıldan 3 yıla kadar",
            "ucilden5ileqeder":"3 yıldan 5 yıla kadar",
            "besildencox":"5 yıldan fazla",
            "dilbilikleri":"Dil becerileri",
            "butunnamizedler":"Tüm adaylar",
            "toplamnamized":"toplam aday",
            "searchnamized":"Aradığınız pozisyonu girin...",
            "sirala":"Sırala",
            "nameasc":"İsme göre A-Z",
            "namedesc":"İsme göre Z-A",
            "positionasc":"Pozisyona göre A-Z",
            "positiondesc":"Pozisyona göre Z-A",
            "salaryasc":"Maaş artan",
            "salarydesc":"Maaş azalan",
            "clear":"Temizle",
            "searchnotfound":"Aramanıza uygun bilgi bulunamadı.",
            "date":"Yayınlandı :",
            "allcompany":"Tüm şirketler",
            "toplamsirket":"toplam şirket",
            "searchcompany":"Şirket arayın",
            "companyasc":"Adına göre (A-Z)",
            "companydesc":"Adına göre (Z-A)",
            "notfoundcompany":"Şirket bulunamadı",
            "city":"Şehir",
            "kateqoriya":"Kategori",
            "maas":"Maaş",
            "yerlesme":"Yayınlanma tarihi",
            "bitme":"Bitiş tarihi",
            "description":"Açıklama :",
            "telebler":"Şartlar :",
            "muraciet":"Başvur",
            "oxsarvakansiya":"Benzer pozisyonlar",
            "elan":"İLAN",
            "vezife":"Pozisyon",
            "buildcareer":"Kariyerinizi bizimle inşa edin!",
            "buildcareerdesc":"Turanozbahceci.az, Azerbaycan'da iş arayanlarla işverenleri buluşturan yenilikçi bir iş platformudur. Son iş ilanları, freelance işler, staj programları ve kariyer gelişimine dair faydalı kaynaklar burada birleşiyor! İş arıyorsunuz? Turanozbahceci.az, size en uygun iş ilanlarını bulmanıza, CV'nizi yüklemenize ve işverenlerle doğrudan iletişim kurmanıza olanak sağlar. Farklı sektörlerdeki iş ilanları, girişim fırsatları, kurumsal ilanlar ve devlet sektöründeki kariyer fırsatları sadece bir tık uzağınızda. İşveren misiniz? Turanozbahceci.az ile ilanlarınızı yayınlayın, geniş iş arayan kitlesine ulaşın ve en uygun adayları hızla bulun. Platformumuz, işe alım sürecini hızlandırır ve sizlere yetenekli adaylarla kolayca görüşme imkanı tanır.",
            "welcome":"Hoş",
            "welcome1":"geldiniz",
            "emekdasliq":"İşbirliği",
            "hesabmelumatlari":"Hesap bilgileri",
            "logout":"Çıkış",
            "panel":"Yönetim paneli",
            "hello":"Merhaba,",
            "paneldesc":"Hesabınızın yönetim panelinden iş ilanlarınızı yayınlayabilir ve görebilirsiniz, gönderi ve ödeme adreslerinizi yönetebilirsiniz, ayrıca şifrenizi ve hesap bilgilerinizi düzenleyebilirsiniz.",
            "username":"Kullanıcı adı soyadı :",
            "sifreniyenile":"Şifreyi yenile",
            "hazirki":"Mevcut şifre",
            "yeni":"Yeni şifre",
            "sifretestiq":"Şifreyi onaylayın",
            "activevac":"Şu an",
            "activevac1":"ilanınız aktif",
            "createjob":"İş ilanı oluştur",
            "iselaniyerlesdirmek":"İş ilanı yayınlamak",
            "min_maas":"Minimum maaş",
            "max_maas":"Maksimum maaş",
            "old":"Yaş",
            "max":"Maksimum",
            "select":"Seçin:",
            "namizedeteleb":"Adaya şartlar",
            "namizedbacariq":"Adayın yetenekleri ve deneyimi hakkında bilgi girin.",
            "isbarede":"İş hakkında bilgi",
            "isinvezifesi":"İşin görevleri ve gereksinimleri hakkında bilgi girin.",
            "companyname":"Şirket adı",
            "elaqedar":"İlgili kişi",
            "yerlesdirin":"Yerleştir",
            "karyerairelileyis":"Kariyerinizi ilerletin",
            "kouc":"Koç",
            "cvyerlesdirmek":"CV yüklemek",
            "fathername":"Baba adı",
            "img":"Resim",
            "etrafli":"Detaylı",
            "ozunuz":"Kendiniz hakkında bilgi.",
            "istecrubesihaqqinda":"İş deneyiminiz hakkında bilgi.",
            "bacariqlar":"Yetenekler",
            "elavemelumat":"Ekstra bilgi",
            "view":"Görünüm",
            "coachingTitle":"Turan Özbahçeci - Koçluk Oturumları ve Kişisel Gelişim Videoları",
            "coachingDesc":"Turan Özbahçeci'nin koçluk oturumları ile hayatınızı değiştirin! Bu videolarda, hedeflerinize ulaşmak, kişisel gelişim ve başarıya ulaşmak için pratik tavsiyeler ve motivasyon bulacaksınız.",
            "abuneol":"Abone ol",
            "month":"ay",
            "year":"yıl",
            "populyar":"EN POPÜLER"
        }
        ,
        "en": {
            "bio": "Biography",
            "isimkanlari": "Opportunities & Growth Hub",
            "karyeramerkezi": "Career Center",
            "karyeramerkezi1": "Job Listings",
            "karyeramerkezi2": "Investment Offers",
            "karyeramerkezi3": "Events & Trainings",
            "insanresurs": "Talent & Partnership Portal",
            "insanresurs1": "CV Bank",
            "insanresurs2": "Partnerships / Startup Projects",
            "investclub": "Özbahçeci Investment Club",
            "projects": "Projects",
            "coaching": "Coaching Sessions",
            "allcoaching": "All Coaching Sessions",
            "news": "News",
            "allnews": "All News",
            "subscribe": "Subscription",
            "subscoaching": "Coaching Sessions",
            "subsisimkanlari": "Job opportunities and development market",
            "subsemek": "Collaboration",
            "signin": "Sign In",
            "homeSliderTitle": "\"Let's write your success story together\"",
            "homeSliderDesc": "\"Don’t procrastinate, don’t delay, don’t give up.\"",
            "homeSliderDesc1": "\"Just believe and focus on the goal.\"",
            "homeSliderTitle1": "\"We are the choice that will make your business successful!\"",
            "whyozbahceci": "Why Özbahçeci?",
            "successprojects": "Our Successful Projects",
            "projectsdesc": "Achieved. Achieving. We will Achieve",
            
            "projectsall": "All",
            "projectstamamlanan": "Achieved",
            "projectstamamlanmayan": "Achieving",
            "projectstamamlanmayan1": "We will Achieve",
            
            "projectsother": "Other Projects",
          
            // These are fixed
            "copyright": "Copyrights reserved.",
            "homedate": "Discover the contents relevant to the date you selected",
            "selectdate": "Select Date",
            "datetitle": "Check detailed information on events, news, photos, online meetings, and sessions related to the selected date.",
            "datedesc": "On this page, you can find detailed information about projects, news, and blogs related to the date you choose. Each date will show information related to relevant content, so you can stay updated with the latest projects and news.",
            "readmore": "Read more",
            "testimonials": "Testimonials",
            "testtitle": "Why do people love <span>*us*?</span>",
            "testdesc": "Would you like to hear what our customers think about our service quality? Here you can find their thoughts. Everything is open and simple, so you’ll be satisfied with us as well.",
            "contactweTitle": "Ask us",
            "contactweDesc": "It is easy to contact us for any questions, suggestions, or support. You can visit our contact page and submit your inquiry. We will get back to you as soon as possible.",
            "contactwe": "Contact Us",
            "contactDesc": "",
            "nameandemail": "Username or email",
            "pass": "Password",
            "check": "Remember me",
            "newprofil": "If you don't have an account, we recommend creating a new one.",
            "createnewprofile": "Create new account.",
            "signup": "Sign Up",
            "name": "Name",
            "lastname": "Last Name",
            "email": "Email",
            "passconfirm": "Confirm Password",
            "mobil": "Mobile",
            "contracttitle": "Read the Agreement and Terms of Use",
            "profil": "Do you have an account?",
            "sucsccontract": "I have read and accept the Agreement and Terms of Use.",
            "contacttitle1": "CONTRACT",
            "more": "More",
            "othernew": "Other news",
            "note": "Your message",
            "submit": "Submit",
            "contactustitle": "Contact Information",
            "contactusdesc": "You can use the information below to contact us. You can also reach us through our social media platforms.",
            "address": "Address",
            "addressDesc": "Baku / Azerbaijan",
            "contactwork": "Working hours",
            "contactworktime": "Monday - Friday",
            "contactworktime1": "Saturday and Sunday",
            "contactsocial": "Our Social Media Accounts",
            "terms": "PORTAL USE TERMS AND CONDITIONS",
            "privacy": "Privacy Policy",
            "bioTitle": "DON'T PROCRASTINATE,</br> DON'T DELAY, </br> DON'T GIVE UP",
            "about": "About",
            "homePage": "Home Page",
            "filter": "Filter",
            "gender": "Gender",
            "man": "Man",
            "woman": "Woman",
            "maasaraligi": "Salary range",
            "maasdan": "From ₼",
            "maasqeder": "Up to ₼",
            "selectcat": "Select category:",
            "allCat": "All categories:",
            "education": "Education:",
            "ali": "Higher",
            "natamam": "Incomplete",
            "orta": "Middle",
            "isrejimi": "Job type",
            "tamstat": "Full-time",
            "yarim": "Part-time",
            "frilans": "Freelance",
            "tecrubeci": "Intern",
            "uzaqdan": "Remote",
            "muveqqeti": "Temporary job",
            "istecrubesi": "Work experience",
            "birildenaz": "Less than 1 year",
            "birildenucileqeder": "1 to 3 years",
            "ucilden5ileqeder": "3 to 5 years",
            "besildencox": "More than 5 years",
            "dilbilikleri": "Language skills",
            "butunnamizedler": "All candidates",
            "toplamnamized": "total candidates",
            "searchnamized": "Enter the position you are looking for...",
            "sirala": "Sort",
            "nameasc": "Name A-Z",
            "namedesc": "Name Z-A",
            "positionasc": "Position A-Z",
            "positiondesc": "Position Z-A",
            "salaryasc": "Salary ascending",
            "salarydesc": "Salary descending",
            "clear": "Clear",
            "searchnotfound": "No results found for your search.",
            "date": "Posted on:",
            "allcompany": "All companies",
            "toplamsirket": "total companies",
            "searchcompany": "Search company",
            "companyasc": "By name (A-Z)",
            "companydesc": "By name (Z-A)",
            "notfoundcompany": "Company not found",
            "city": "City",
            "kateqoriya": "Category",
            "maas": "Salary",
            "yerlesme": "Placement date",
            "bitme": "End date",
            "description": "Description:",
            "telebler": "Requirements:",
            "muraciet": "Apply",
            "oxsarvakansiya": "Similar vacancies",
            "elan": "ADVERTISEMENT",
            "vezife": "Position",
            "buildcareer": "Build your career with us!",
            "buildcareerdesc": "Turanozbahceci.az is an innovative job platform that brings job seekers and employers together in Azerbaijan. The latest vacancies, freelance jobs, internship programs, and career development resources are combined here! Looking for a job? Turanozbahceci.az helps you find the most suitable job offers, upload your CV, and connect directly with employers. Vacancies in various fields, startup opportunities, corporate advertisements, and career opportunities in the public sector are just a click away. Are you an employer? Post your ads with Turanozbahceci.az, access a large pool of job seekers, and find the best candidates quickly. Our platform accelerates the recruitment process and allows you to meet talented candidates easily.",
            "welcome": "Welcome",
            "welcome1": "you have arrived",
            "emekdasliq": "Collaboration",
            "hesabmelumatlari": "Account information",
            "logout": "Logout",
            "panel": "Dashboard",
            "hello": "Hello,",
            "paneldesc": "From your account dashboard, you can place and view job ads, manage your submission and payment addresses, and edit your password and account information.",
            "username": "Username and surname:",
            "sifreniyenile": "Change password",
            "hazirki": "Current password",
            "yeni": "New password",
            "sifretestiq": "Confirm password",
            "activevac": "Currently",
            "activevac1": "your vacancy is active",
            "createjob": "Create job ad",
            "iselaniyerlesdirmek": "Post job ad",
            "min_maas": "Minimum salary",
            "max_maas": "Maximum salary",
            "old": "Age",
            "max": "Maximum",
            "select": "Select:",
            "namizedeteleb": "Candidate requirements",
            "namizedbacariq": "Enter candidate skills and experience details.",
            "isbarede": "Job description",
            "isinvezifesi": "Enter job responsibilities and requirements.",
            "companyname": "Company name",
            "elaqedar": "Contact person",
            "yerlesdirin": "Post",
            "karyerairelileyis": "Career Development",
            "kouc": "Coach",
            "cvyerlesdirmek": "Upload CV",
            "fathername": "Father's name",
            "img": "Image",
            "etrafli": "Details",
            "ozunuz": "About yourself.",
            "istecrubesihaqqinda": "Information about your work experience.",
            "bacariqlar": "Skills",
            "elavemelumat": "Additional information",
            "view": "View",
            "coachingTitle": "Turan Özbahçeci - Coaching Sessions and Personal Development Videos",
            "coachingDesc": "Transform your life with Turan Özbahçeci's coaching sessions! In these videos, you’ll find practical tips and motivation to achieve your goals, personal growth, and success.",
            "abuneol": "Subscribe",
            "month": "month",
            "year": "year",
            "populyar": "MOST POPULAR"
          }
          ,
        "ru": {
            "bio": "Биография",
            "isimkanlari": "Платформа Возможностей и Развития",
            "karyeramerkezi": "Центр карьеры",
            "karyeramerkezi1": "Вакансии",
            "karyeramerkezi2": "Инвестиционные предложения",
            "karyeramerkezi3": "Мероприятия и Обучения",
            "insanresurs": "Портал Талантов и Партнёрства",
            "insanresurs1": "База Резюме",
            "insanresurs2": "Партнёрства / Стартап-проекты",
            "investclub": "Инвестиционный клуб Özbahçeci",
            "projects": "Проекты",
            "coaching": "Сессии коучинга",
            "allcoaching": "Все сессии коучинга",
            "news": "Новости",
            "allnews": "Все новости",
            "subscribe": "Подписка",
            "subscoaching": "Сессии коучинга",
            "subsisimkanlari": "Вакансии и рынок развития",
            "subsemek": "Сотрудничество",
            "signin": "Войти",
            "homeSliderTitle": "“Давайте напишем вашу историю успеха вместе”",
            "homeSliderDesc": '"Не сдавайтесь, не откладывайте, не отказывайтесь."',
            "homeSliderDesc1": '"Просто верьте и сосредоточьтесь на цели."',
            "homeSliderTitle1": "“Мы — выбор, который сделает ваш бизнес успешным!”",
            "whyozbahceci": "Почему Özbahçeci?",
            "successprojects": "Успешные проекты",
            "projectsdesc": "Успех в Прошлом, Прогресс Сегодня, Вершина Завтра!",
          
            "projectsall": "Все",
            "projectstamamlanan": "Добились",
            "projectstamamlanmayan": "Двигаемся",
            "projectstamamlanmayan1": "Добьемся!",
          
            "projectsother":"Другие наши проекты",


            "copyright": "Авторские права защищены.",
  "homedate": "Откройте контент, соответствующий выбранной вами дате",
  "selectdate": "Выбор даты",
  "datetitle": "Просмотрите подробную информацию о мероприятиях, новостях, фотографиях, онлайн-встречах и сессиях, соответствующих выбранной дате.",
  "datedesc": "На этой странице вы можете получить подробную информацию о проектах, новостях и блогах в зависимости от выбранной даты. Каждая дата представляет информацию, связанную с соответствующим контентом, чтобы вы могли быть в курсе последних новостей и проектов.",
  "readmore": "Читать далее",
  "testimonials": "Отзывы",
  "testtitle": "Почему люди *любят* нас?",
  "testdesc": "Хотите узнать, что думают люди о качестве нашего сервиса? Здесь вы найдете мнения наших клиентов. Все ясно и понятно, так что вы тоже будете полностью довольны нами.",
  "contactweTitle": "Задайте нам вопрос",
  "contactweDesc": "Очень легко связаться с нами по вопросам, предложениям или другим вопросам. Вы можете посетить нашу страницу контактов и отправить свой запрос. Мы свяжемся с вами как можно скорее.",
  "contactwe": "Связаться с нами",
  "contactDesc": "",
  "nameandemail": "Имя пользователя или электронная почта",
  "pass": "Пароль",
  "check": "Запомнить меня",
  "newprofil": "Если у вас нет учетной записи, рекомендуется создать новую.",
  "createnewprofile": "Создать новый аккаунт.",
  "signup": "Зарегистрироваться",
  "name": "Имя",
  "lastname": "Фамилия",
  "email": "Электронная почта",
  "passconfirm": "Подтвердите пароль",
  "mobil": "Мобильный",
  "contracttitle": "Прочитайте контракт и условия использования",
  "profil": "У вас есть аккаунт?",
  "sucsccontract": "Я прочитал и принимаю условия контракта и использования.",
  "contacttitle1": "КОНТРАКТ",
  "more": "Больше",
  "othernew": "Другие новости",
  "note": "Ваше сообщение",
  "submit": "Отправить",
  "contactustitle": "Контактная информация",
  "contactusdesc": "Вы можете использовать информацию ниже, чтобы связаться с нами. Вы также можете связаться с нами через наши социальные сети.",
  "address": "Адрес",
  "addressDesc": "Баку / Азербайджан",
  "contactwork": "Рабочие часы",
  "contactworktime": "Понедельник - Пятница",
  "contactworktime1": "Суббота и Воскресенье",
  "contactsocial": "Наши социальные сети",
  "terms": "УСЛОВИЯ И ПОЛОЖЕНИЯ ПОРТАЛА",
  "privacy": "Политика конфиденциальности",
  "bioTitle": "ПРОКРАСТИНАЦИЯ, </br>ОТЛОЖЕНИЕ, </br> СДАЧА",
  "about": "О нас",
  "homePage": "Главная страница",
  "filter": "Фильтр",
  "gender": "Пол",
  "man": "Мужской",
  "woman": "Женский",
  "maasaraligi": "Диапазон зарплаты",
  "maasdan": "От ₺",
  "maasqeder": "До ₺",
  "selectcat": "Выберите категорию:",
  "allCat": "Все категории:",
  "education": "Образование:",
  "ali": "Университет",
  "natamam": "Незавершенное",
  "orta": "Среднее образование",
  "isrejimi": "Режим работы",
  "tamstat": "Полная занятость",
  "yarim": "Частичная занятость",
  "frilans": "Фриланс",
  "tecrubeci": "Стажер",
  "uzaqdan": "Удаленно",
  "muveqqeti": "Временная работа",
  "istecrubesi": "Опыт работы",
  "birildenaz": "Менее 1 года",
  "birildenucileqeder": "От 1 до 3 лет",
  "ucilden5ileqeder": "От 3 до 5 лет",
  "besildencox": "Более 5 лет",
  "dilbilikleri": "Языковые навыки",
  "butunnamizedler": "Все кандидаты",
  "toplamnamized": "Общее количество кандидатов",
  "searchnamized": "Введите должность, которую ищете...",
  "sirala": "Сортировать",
  "nameasc": "По имени A-Z",
  "namedesc": "По имени Z-A",
  "positionasc": "По должности A-Z",
  "positiondesc": "По должности Z-A",
  "salaryasc": "По возрастанию зарплаты",
  "salarydesc": "По убыванию зарплаты",
  "clear": "Очистить",
  "searchnotfound": "Информация, соответствующая вашему запросу, не найдена.",
  "date": "Дата публикации:",
  "allcompany": "Все компании",
  "toplamsirket": "Общее количество компаний",
  "searchcompany": "Поиск компании",
  "companyasc": "По имени (A-Z)",
  "companydesc": "По имени (Z-A)",
  "notfoundcompany": "Компания не найдена",
  "city": "Город",
  "kateqoriya": "Категория",
  "maas": "Зарплата",
  "yerlesme": "Дата размещения",
  "bitme": "Дата окончания",
  "description": "Описание:",
  "telebler": "Требования:",
  "muraciet": "Подать заявку",
  "oxsarvakansiya": "Похожие вакансии",
  "elan": "ОБЪЯВЛЕНИЕ",
  "vezife": "Должность",
  "buildcareer": "Стройте свою карьеру с нами!",
  "abuneol": "Подписаться",
  "month": "месяц",
  "year": "год",
  "populyar": "САМЫЕ ПОПУЛЯРНЫЕ",
  "buildcareerdesc": "Turanozbahceci.az — это инновационная платформа для поиска работы, которая соединяет соискателей и работодателей в Азербайджане. Здесь объединяются последние объявления о работе, фриланс, стажировки и полезные ресурсы для развития карьеры!"

        },
        "de": {
            "bio": "Biografie",
            "isimkanlari": "Arbeitsmöglichkeiten und Entwicklungsmarkt",
            "karyeramerkezi": "Karrierezentrum",
            "karyeramerkezi1": "Stellenangebote",
            "karyeramerkezi2": "Investitionsangebote",
            "karyeramerkezi3": "Veranstaltungs- und Schulungsankündigungen",
            "insanresurs": "Personalportal",
            "insanresurs1": "CV-Datenbank",
            "insanresurs2": "Projektbank",
            "investclub": "Özbahçeci Invest Club",
            "projects": "Projekte",
            "coaching": "Coaching-Sitzungen",
            "allcoaching": "Alle Coaching-Sitzungen",
            "news": "Nachrichten",
            "allnews": "Alle Nachrichten",
            "subscribe": "Abonnement",
            "subscoaching": "Coaching-Sitzungen",
            "subsisimkanlari": "Arbeitsmöglichkeiten und Entwicklungsmarkt",
            "subsemek": "Kooperation",
            "signin": "Anmelden",
            "homeSliderTitle": "“Lassen Sie uns gemeinsam Ihre Erfolgsgeschichte schreiben”",
            "homeSliderDesc": '"Gib nicht auf, zögere nicht, hör nicht auf."',
            "homeSliderDesc1": '"Glaube einfach und konzentriere dich auf das Ziel."',
            "homeSliderTitle1": "“Wir sind die Wahl, die Ihr Geschäft erfolgreich macht!”",
            "whyozbahceci": "Warum Özbahçeci?",
            "successprojects": "Erfolgreiche Projekte",
            "projectsdesc": "Das Port Baku Bazar-Projekt, ein Meilenstein, ist der erste und einzige VIP-Shop in Aserbaidschan, eröffnet von Turan Özbahçeci.",
            "projectsall": "Alle",
            "projectstamamlanan": "Abgeschlossene Projekte",
            "projectstamamlanmayan": "Unvollständige Projekte",
            "projectsother":"Andere Projekte von uns",


            "copyright": "Alle Rechte vorbehalten.",
  "homedate": "Entdecken Sie Inhalte, die Ihrem ausgewählten Datum entsprechen",
  "selectdate": "Datum auswählen",
  "datetitle": "Durchsuchen Sie detaillierte Informationen zu Veranstaltungen, Nachrichten, Fotos, Online-Meetings und Sitzungen, die dem ausgewählten Datum entsprechen.",
  "datedesc": "Auf dieser Seite können Sie detaillierte Informationen zu Projekten, Nachrichten und Blogs entsprechend dem gewählten Datum abrufen. Jedes Datum bietet Informationen zu den entsprechenden Inhalten, damit Sie immer auf dem neuesten Stand bezüglich Projekten und Nachrichten bleiben.",
  "readmore": "Mehr lesen",
  "testimonials": "Testimonials",
  "testtitle": "Warum lieben die Leute *uns*?",
  "testdesc": "Möchten Sie wissen, was die Leute über die Qualität unseres Service denken? Hier finden Sie die Meinungen unserer Kunden. Alles ist klar und verständlich, damit Sie ebenfalls vollkommen zufrieden mit uns sind.",
  "contactweTitle": "Fragen Sie uns",
  "contactweDesc": "Es ist sehr einfach, uns für Fragen, Vorschläge oder andere Anliegen zu kontaktieren. Sie können unsere Kontaktseite besuchen und uns Ihre Anfrage senden. Wir werden uns so schnell wie möglich bei Ihnen melden.",
  "contactwe": "Kontaktieren Sie uns",
  "contactDesc": "",
  "nameandemail": "Benutzername oder E-Mail",
  "pass": "Passwort",
  "check": "Mich erinnern",
  "newprofil": "Wenn Sie kein Konto haben, wird empfohlen, ein neues zu erstellen.",
  "createnewprofile": "Neues Konto erstellen.",
  "signup": "Registrieren",
  "name": "Vorname",
  "lastname": "Nachname",
  "email": "E-Mail",
  "passconfirm": "Passwort bestätigen",
  "mobil": "Mobil",
  "contracttitle": "Vertrag und Nutzungsbedingungen lesen",
  "profil": "Haben Sie ein Konto?",
  "sucsccontract": "Ich habe die Vertrags- und Nutzungsbedingungen gelesen und akzeptiere sie.",
  "contacttitle1": "VERTRAG",
  "more": "Mehr",
  "othernew": "Weitere Nachrichten",
  "note": "Ihre Nachricht",
  "submit": "Absenden",
  "contactustitle": "Kontaktinformationen",
  "contactusdesc": "Sie können uns über die folgenden Informationen kontaktieren. Sie können auch über unsere sozialen Medien mit uns in Kontakt treten.",
  "address": "Adresse",
  "addressDesc": "Baku / Aserbaidschan",
  "contactwork": "Arbeitszeiten",
  "contactworktime": "Montag - Freitag",
  "contactworktime1": "Samstag und Sonntag",
  "contactsocial": "Unsere sozialen Netzwerke",
  "terms": "PORTAL NUTZUNGSBEDINGUNGEN UND VORSCHRIFTEN",
  "privacy": "Datenschutzrichtlinie",
  "bioTitle": "PROKRASTINATION, </br>VERSCHIEBUNG, </br> AUFGEBEN",
  "about": "Über uns",
  "homePage": "Startseite",
  "filter": "Filter",
  "gender": "Geschlecht",
  "man": "Mann",
  "woman": "Frau",
  "maasaraligi": "Gehaltsbereich",
  "maasdan": "Ab ₺",
  "maasqeder": "Bis ₺",
  "selectcat": "Kategorie auswählen:",
  "allCat": "Alle Kategorien:",
  "education": "Ausbildung:",
  "ali": "Universität",
  "natamam": "Unvollständig",
  "orta": "Schule",
  "isrejimi": "Arbeitsmodus",
  "tamstat": "Vollzeit",
  "yarim": "Teilzeit",
  "frilans": "Freelance",
  "tecrubeci": "Praktikant",
  "uzaqdan": "Fernarbeit",
  "muveqqeti": "Befristet",
  "istecrubesi": "Berufserfahrung",
  "birildenaz": "Weniger als 1 Jahr",
  "birildenucileqeder": "Von 1 bis 3 Jahren",
  "ucilden5ileqeder": "Von 3 bis 5 Jahren",
  "besildencox": "Mehr als 5 Jahre",
  "dilbilikleri": "Sprachkenntnisse",
  "butunnamizedler": "Alle Kandidaten",
  "toplamnamized": "Gesamtzahl der Kandidaten",
  "searchnamized": "Geben Sie die Position ein, die Sie suchen...",
  "sirala": "Sortieren",
  "nameasc": "Nach Name A-Z",
  "namedesc": "Nach Name Z-A",
  "positionasc": "Nach Position A-Z",
  "positiondesc": "Nach Position Z-A",
  "salaryasc": "Nach Gehalt aufsteigend",
  "salarydesc": "Nach Gehalt absteigend",
  "clear": "Löschen",
  "searchnotfound": "Keine Informationen gefunden, die Ihrer Suche entsprechen.",
  "date": "Veröffentlichungsdatum:",
  "allcompany": "Alle Unternehmen",
  "toplamsirket": "Gesamtzahl der Unternehmen",
  "searchcompany": "Unternehmen suchen",
  "companyasc": "Nach Name (A-Z)",
  "companydesc": "Nach Name (Z-A)",
  "notfoundcompany": "Unternehmen nicht gefunden",
  "city": "Stadt",
  "kateqoriya": "Kategorie",
  "maas": "Gehalt",
  "yerlesme": "Veröffentlichungsdatum",
  "bitme": "Enddatum",
  "description": "Beschreibung:",
  "telebler": "Anforderungen:",
  "muraciet": "Bewerben",
  "oxsarvakansiya": "Ähnliche Stellenangebote",
  "elan": "ANZEIGE",
  "vezife": "Position",
  "buildcareer": "Bauen Sie Ihre Karriere mit uns auf!",
  "abuneol": "Abonnieren",
  "month": "Monat",
  "year": "Jahr",
  "populyar": "AM BELIEBTESTEN",
  "buildcareerdesc": "Turanozbahceci.az ist eine innovative Jobplattform, die Arbeitssuchende und Arbeitgeber in Aserbaidschan verbindet. Hier finden Sie die neuesten Stellenangebote, Freelance-Arbeiten, Praktika und nützliche Ressourcen zur Karriereentwicklung!"

        },
        "pl": {
            "bio": "Biografia",
            "isimkanlari": "Możliwości pracy i rynek rozwoju",
            "karyeramerkezi": "Centrum kariery",
            "karyeramerkezi1": "Oferty pracy",
            "karyeramerkezi2": "Oferty inwestycyjne",
            "karyeramerkezi3": "Ogłoszenia o wydarzeniach i szkoleniach",
            "insanresurs": "Portal zasobów ludzkich",
            "insanresurs1": "Bank CV",
            "insanresurs2": "Bank projektów",
            "investclub": "Özbahçeci Investment Club",
            "projects": "Projekty",
            "coaching": "Sesje coachingowe",
            "allcoaching": "Wszystkie sesje coachingowe",
            "news": "Wiadomości",
            "allnews": "Wszystkie wiadomości",
            "subscribe": "Subskrypcja",
            "subscoaching": "Sesje coachingowe",
            "subsisimkanlari": "Możliwości pracy i rynek rozwoju",
            "subsemek": "Współpraca",
            "signin": "Zaloguj się",
            "homeSliderTitle": "“Napiszmy razem Twoją historię sukcesu”",
            "homeSliderDesc": '"Nie poddawaj się, nie odkładaj, nie rezygnuj."',
            "homeSliderDesc1": '"Po prostu uwierz i skup się na celu."',
            "homeSliderTitle1": "“Jesteśmy wyborem, który uczyni Twój biznes udanym!”",
            "whyozbahceci": "Dlaczego Özbahçeci?",
            "successprojects": "Udane projekty",
            "projectsdesc": "Projekt Port Baku Bazar, który stał się kamieniem milowym, to pierwszy i jedyny VIP sklep w Azerbejdżanie, otwarty przez Turana Özbahçeci.",
            "projectsall": "Wszystko",
            "projectstamamlanan": "Zrealizowane projekty",
            "projectstamamlanmayan": "Niezrealizowane projekty",
            "projectsother":"Inne nasze projekty",

            "copyright": "Wszelkie prawa zastrzeżone.",
            "homedate": "Odkrywaj treści odpowiednie do wybranego daty",
            "selectdate": "Wybierz datę",
            "datetitle": "Przeglądaj szczegółowe informacje na temat wydarzeń, wiadomości, zdjęć, spotkań online i sesji pasujących do wybranej daty.",
            "datedesc": "Na tej stronie możesz uzyskać szczegółowe informacje na temat projektów, wiadomości i blogów odpowiednich do wybranej daty. Każda data zawiera informacje o powiązanych treściach, dzięki czemu zawsze możesz być na bieżąco z projektami i wiadomościami.",
            "readmore": "Czytaj więcej",
            "testimonials": "Opinie",
            "testtitle": "Dlaczego ludzie kochają *nas*?",
            "testdesc": "Chcesz wiedzieć, co klienci myślą o jakości naszej usługi? Tutaj znajdziesz opinie naszych klientów. Wszystko jest jasne i przejrzyste, abyś był w pełni zadowolony z naszej współpracy.",
            "contactweTitle": "Zapytaj nas",
            "contactweDesc": "Łatwo jest skontaktować się z nami w sprawie pytań, sugestii lub innych kwestii. Możesz odwiedzić naszą stronę kontaktową, aby wysłać nam zapytanie. Skontaktujemy się z Tobą tak szybko, jak to możliwe.",
            "contactwe": "Skontaktuj się z nami",
            "contactDesc": "",
            "nameandemail": "Nazwa użytkownika lub e-mail",
            "pass": "Hasło",
            "check": "Zapamiętaj mnie",
            "newprofil": "Jeśli nie masz konta, zaleca się utworzenie nowego.",
            "createnewprofile": "Utwórz nowe konto.",
            "signup": "Zarejestruj się",
            "name": "Imię",
            "lastname": "Nazwisko",
            "email": "E-mail",
            "passconfirm": "Potwierdź hasło",
            "mobil": "Telefon",
            "contracttitle": "Przeczytaj umowę i warunki użytkowania",
            "profil": "Masz konto?",
            "sucsccontract": "Przeczytałem i akceptuję umowę oraz warunki użytkowania.",
            "contacttitle1": "UMOWA",
            "more": "Więcej",
            "othernew": "Inne nasze wiadomości",
            "note": "Twoja wiadomość",
            "submit": "Wyślij",
            "contactustitle": "Informacje kontaktowe",
            "contactusdesc": "Możesz skontaktować się z nami, korzystając z poniższych informacji. Możesz również skontaktować się z nami za pośrednictwem naszych mediów społecznościowych.",
            "address": "Adres",
            "addressDesc": "Baku / Azerbejdżan",
            "contactwork": "Godziny pracy",
            "contactworktime": "Poniedziałek - Piątek",
            "contactworktime1": "Sobota i Niedziela",
            "contactsocial": "Nasze media społecznościowe",
            "terms": "WARUNKI I ZASADY KORZYSTANIA Z PORTALU",
            "privacy": "Polityka prywatności",
            "bioTitle": "PROKRASTYNACJA, </br>OPÓŹNIANIE, </br> PODDAWANIE SIĘ",
            "about": "O nas",
            "homePage": "Strona główna",
            "filter": "Filtr",
            "gender": "Płeć",
            "man": "Mężczyzna",
            "woman": "Kobieta",
            "maasaraligi": "Zakres wynagrodzenia",
            "maasdan": "Od ₺",
            "maasqeder": "Do ₺",
            "selectcat": "Wybierz kategorię:",
            "allCat": "Wszystkie kategorie:",
            "education": "Edukacja:",
            "ali": "Uniwersytet",
            "natamam": "Niedokończone",
            "orta": "Szkoła średnia",
            "isrejimi": "Tryb pracy",
            "tamstat": "Pełny etat",
            "yarim": "Część etatu",
            "frilans": "Freelance",
            "tecrubeci": "Stażysta",
            "uzaqdan": "Praca zdalna",
            "muveqqeti": "Praca tymczasowa",
            "istecrubesi": "Doświadczenie zawodowe",
            "birildenaz": "Mniej niż 1 rok",
            "birildenucileqeder": "Od 1 do 3 lat",
            "ucilden5ileqeder": "Od 3 do 5 lat",
            "besildencox": "Ponad 5 lat",
            "dilbilikleri": "Znajomość języków",
            "butunnamizedler": "Wszyscy kandydaci",
            "toplamnamized": "Łączna liczba kandydatów",
            "searchnamized": "Wpisz stanowisko, które chcesz znaleźć...",
            "sirala": "Sortuj",
            "nameasc": "Po nazwisku A-Z",
            "namedesc": "Po nazwisku Z-A",
            "positionasc": "Po stanowisku A-Z",
            "positiondesc": "Po stanowisku Z-A",
            "salaryasc": "Wzrost pensji",
            "salarydesc": "Spadek pensji",
            "clear": "Wyczyść",
            "searchnotfound": "Nie znaleziono wyników odpowiadających Twojemu zapytaniu.",
            "date": "Data publikacji:",
            "allcompany": "Wszystkie firmy",
            "toplamsirket": "Łączna liczba firm",
            "searchcompany": "Szukaj firmy",
            "companyasc": "Po nazwie (A-Z)",
            "companydesc": "Po nazwie (Z-A)",
            "notfoundcompany": "Nie znaleziono firmy",
            "city": "Miasto",
            "kateqoriya": "Kategoria",
            "maas": "Wynagrodzenie",
            "yerlesme": "Data publikacji",
            "bitme": "Data zakończenia",
            "description": "Opis:",
            "telebler": "Wymagania:",
            "muraciet": "Aplikuj",
            "oxsarvakansiya": "Podobne oferty pracy",
            "elan": "OGŁOSZENIE",
            "vezife": "Stanowisko",
            "buildcareer": "Buduj swoją karierę z nami!",
            "abuneol": "Subskrybuj",
            "month": "miesiąc",
            "year": "rok",
            "populyar": "NAJPOPULARNIEJSZE",
            "buildcareerdesc": "Turanozbahceci.az to innowacyjna platforma pracy łącząca osoby szukające pracy z pracodawcami w Azerbejdżanie. Najnowsze oferty pracy, freelance, programy stażowe i przydatne zasoby rozwoju kariery są tutaj połączone!"


        }
    }


    export default translations ;